"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternationalProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var zh_CN_1 = __importDefault(require("antd/locale/zh_CN"));
var react_1 = require("react");
var supportedLanguages = {
    zhCN: zh_CN_1.default,
};
var InternationalContextInternal = (0, react_1.createContext)("zhCN");
function InternationalProvider(props) {
    return (0, jsx_runtime_1.jsx)(InternationalContextInternal.Provider, __assign({ value: props.language }, { children: (0, jsx_runtime_1.jsx)(antd_1.ConfigProvider, __assign({ locale: supportedLanguages[props.language] }, { children: props.children })) }));
}
exports.InternationalProvider = InternationalProvider;
